import {getDeviceInfo} from './bootstrap';

const platforms = {
    DESKTOP: 'Desktop',
    MOBILE: 'Mobile',
    TABLET: 'Tablet',
    UNKNOWN: 'Unknown'
};

export const deviceDetector = {
    get isMobileDevice() {
        try {
            const userDevice = getDeviceInfo();
            if (
                userDevice.Type === platforms.MOBILE ||
                userDevice.Type === platforms.TABLET
            ) {
                return true;
            }
        } catch (error) {
            return false;
        }
        return false;
    },
    get isNotMobileDevice() {
        return !this.isMobileDevice;
    },
    get isPhoneOnlyDevice() {
        try {
            const userDevice = getDeviceInfo();
            if (userDevice.Type === platforms.MOBILE) {
                return true;
            }
        } catch (error) {
            return false;
        }
        return false;
    },
    get isInternetExplorer11() {
        try {
            const userDevice = getDeviceInfo();

            return (
                userDevice.Browser === 'InternetExplorer' &&
                userDevice.BrowserVersion === '11'
            );
        } catch (error) {
            return false;
        }
    },
    get isChrome() {
        try {
            const userDevice = getDeviceInfo();
            return userDevice.Browser === 'Chrome';
        } catch (error) {
            return false;
        }
    },
    get isFirefox() {
        try {
            const userDevice = getDeviceInfo();

            return userDevice.Browser === 'Firefox';
        } catch (error) {
            return false;
        }
    }
};
